<template>
  <div id="terminal_main">
    <div id="terminal_header" class="terminal_header">
      <!-- <span id="ssh_title">SSH</span> -->
      <sis-select
        :options="servers"
        :label="translate('server.one')"
        :placeholder="translate('server.one')"
        v-model="ssh_server"
        :clearable="false"
        :disabled="this.$store.getters.getStatus"
      />

      <fg-input
          class="ssh_login"
          name="ssh_login"
          v-model="ssh_login"
          type="text"
          label="login"
          placeholder="login"
          :disabled="this.$store.getters.getStatus"
      />
      <fg-input
          class="ssh_password"
          name="ssh_password"
          v-model="ssh_password"
          type="password"
          label="password"
          placeholder="password"
          :disabled="this.$store.getters.getStatus"
      />
      <span
        type="submit"
        class="btn btn-success btn-wd btn_connect"
        @click="start_connect()"
      >
        {{ this.$store.getters.getStatus ? 'Disconnect' : 'Connect' }}
      </span>
    </div>
    <div id="terminal" class="terminal" ref="terminal"></div>
  </div>
</template>

<script>

import { Terminal } from 'xterm'
import 'xterm/css/xterm.css'
import { FitAddon } from "xterm-addon-fit"

export default {
  name: "Ssh",
  props: ["dev_id", "servers"],
  data() {
    return {
      socket: null,
      connection: null,
      btnText: "",
      tm: null,
      connect_data: null,
      term: null,
      fitAddon: null,
      windowHeight: window.innerHeight,
      ssh_login: 'root',
      ssh_password: '',
      ssh_server: {},
      timer_connect: 0,
    };
  },
  created() {
    document.addEventListener('keyup', (evt) => {
      if (this.$route.params.device_section === 'ssh') {
        this.$store.commit('resetTimer')
        if(evt.key === 'Enter' && this.$store.getters.getConnection === null){
          this.start_connect()
        }
      }
    });

    this.timer_connect = this.$store.getters.getTimerConnect
    if (this.timer_connect === 0) {
      setInterval(() => {
        if (this.$store.getters.getTimerConnect > 600) { //Таймер на бездействие втечении 10 минут
          if (this.$store.getters.getConnection != null) {
            this.close_connection()
          }
        }else{
          this.$store.commit('setTimerConnect', this.$store.getters.getTimerConnect + 1)
        }
      }, this.$store.getters.getCountdown)
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.updateConnectStatus();

    let terminalContainer = document.getElementById('terminal')
    this.ssh_server = this.servers[0].id

    if (this.dev_id === this.$store.getters.getDeviceID) {

      this.term = this.$store.getters.getTerm
      this.fitAddon = this.$store.getters.getFitAddon
      this.term.open(terminalContainer)
      this.term._initialized = true
      this.term.loadAddon(this.fitAddon)
      this.fitAddon.fit();

      this.this_focus()

    }else{
      if (this.$store.getters.getStatus) {
        this.$store.getters.getConnection.send(JSON.stringify({ cmd: "close" }));
        this.$store.getters.getConnection.close();
        this.$store.commit('resetState')
      }

      this.term = new Terminal({rows: 40, cols: 150})
      this.fitAddon = new FitAddon();
      this.term.open(terminalContainer)
      this.term._initialized = true
      this.term.loadAddon(this.fitAddon)

      this.term.onKey(e => {
        this.$store.getters.getConnection.send(JSON.stringify({ cmd: "run", data: e.key }))
      });
    }

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    close_connection(){
      if (this.isConnect()) {
        this.$store.getters.getConnection.send(JSON.stringify({ cmd: "close" }));
        this.$store.getters.getConnection.close();
      }
      this.$store.commit('resetState')
      this.connect_data = null
      this.ssh_password = ''
    },
    this_focus(){
      this.$el.querySelector("#terminal .terminal.xterm .xterm-screen .xterm-helpers .xterm-helper-textarea").focus()
    },
    sendResize(){
      if (this.$store.getters.getConnection && this.$store.getters.getConnection.readyState === 1) {
        this.$store.getters.getConnection.send(JSON.stringify({
          cmd: "resize",
          data: {
            width: this.$refs.terminal.querySelector('.xterm-screen').clientWidth,
            height: this.$refs.terminal.querySelector('.xterm-screen').clientHeight,
            rows: 40,
            cols: 150
          }
        }))
      }
    },
    onResize() {
      this.fitAddon.fit();
      this.windowHeight = window.innerHeight
      this.sendResize()
    },

    ping() {
      if (this.isConnect()) {
        this.$store.getters.getConnection.send(JSON.stringify({ cmd: "ping" }));
        var self = this;
        this.tm = setTimeout(function () {
          //disconnect
          self.updateConnectStatus();
        }, 5000);
      }
    },
    pong() {
      clearTimeout(this.tm);
    },
    start_connect(){
      if(this.$store.getters.getConnection == null){
        let server = {}
        for (let serv of this.servers) {
          if (serv.id === this.ssh_server){
            server = serv
          }
        }

        this.$http.v1.getToken({ device_fid: this.dev_id, login: this.ssh_login, password: this.ssh_password, server_ip: server.ip, server_port: server.port }, (response) => {
            this.connect_data = response.data
            this.connect();
        });
      }
      if(this.isConnect()) {
        this.$store.getters.getConnection.send(JSON.stringify({ cmd: "close" }));
        this.$store.getters.getConnection.close();
        this.$store.commit('resetState')
        this.$set(this, 'connection', null)
        this.ssh_password = ''
        // this.updateConnectStatus();
      }
    },
    connect() {
      if (!this.$store.getters.getConnection) {
        let address = this.connect_data.proxy_url+"/"
        this.$store.commit('setConnection', new WebSocket(address))
        this.$store.commit('setDeviceID', this.dev_id)
        this.$store.commit('setStatus', true)

        this.term.write('\r\n');
        this.this_focus()

        this.$store.getters.getConnection.onmessage = (event) => {
          if(event.data) {
            let cmd = JSON.parse(event.data);
            if(cmd.cmd === 'pong'){
              this.pong();
            }else if(cmd.cmd === "stdout") {
              this.fitAddon.fit();
              this.term.write(cmd.data)
            }else if(cmd.cmd === 'need_resize'){
              this.sendResize()
            }
          }
          this.$store.commit('setTerm', this.term)
          this.$store.commit('setFitAddon', this.fitAddon)
        };
        this.$store.getters.getConnection.onerror = () => {
          this.updateConnectStatus();
        };
        this.$store.getters.getConnection.onopen = () => {
          this.updateConnectStatus();
          setInterval(this.ping, this.$store.getters.getPingSsh);
          this.$store.getters.getConnection.send(
            JSON.stringify({
              cmd: "token",
              data: {
                token: this.connect_data.token,
                server: this.connect_data.check_token_server_url
              }
            })
          );
        };
        this.$store.getters.getConnection.onclose = () => {
          this.close_connection()
        }
      }
    },
    isConnect() {
      return !!(this.$store.getters.getConnection && this.$store.getters.getConnection.readyState === WebSocket.OPEN);
    },
    updateConnectStatus() {
      // if (this.isConnect()) {
      //   this.btnText = "Disconnect";
      // } else {
      //   this.btnText = "Connect";
      // }
    },
  },
};
</script>
<style lang='scss' scoped>
body {
  margin: 0;
  padding: 0;
}

#terminal_main{
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
}
#terminal_header{
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 20px;
  .form-group{
    margin-bottom: 0;
    margin-right: 10px;
    width: 20%;
  }
  .btn{
    height: 40px;
  }
}

.terminal {
  width: 100%;
  border-left: 5px solid black;
}

.btn_connect {
  float: right;
}
</style>
